/**
 * Created by alvinoktavianus on 6/21/17.
 */

import {
  BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE,
  BILLING_REDIRECT_SET_NOTIFICATION_TYPE,
  BILLING_REDIRECT_UPDATE_PAYMENT_STATUS
} from './constant'

export function updatePaymentStatus (orderId, statusCode, transactionStatus) {
  return {
    type: BILLING_REDIRECT_UPDATE_PAYMENT_STATUS,
    payload: {orderId, statusCode, transactionStatus}
  }
}

export function setNotificationMessage (notifMessage) {
  return {
    type: BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE,
    payload: {notifMessage}
  }
}

export function setNotificationType (notifType) {
  return {
    type: BILLING_REDIRECT_SET_NOTIFICATION_TYPE,
    payload: {notifType}
  }
}



// WEBPACK FOOTER //
// ./app/actions/billingRedirect/index.js